import React from 'react';

import awsconfig from '../aws-exports';
import { type AppEnvironment, getAppEnvironment } from '../utils/appEnvironment';
import BEM from '../utils/BEM';

import './EnvironmentBadge.sass';

const classes = BEM('environment-badge');

export const currentAppEnvironment: AppEnvironment = getAppEnvironment({
    userPoolId: (awsconfig as { aws_user_pools_id?: string }).aws_user_pools_id,
    isDev: import.meta.env.DEV,
});

// (#3227) Na známém testovacím prostředí červený přetisk, ve vývojovém režimu nad produkcí oranžový.
// V produkčním buildu nad produkcí a u neznámého poolu se nevykreslí nic.
export function EnvironmentBadge(props: { environment?: AppEnvironment }) {
    const environment = props.environment ?? currentAppEnvironment;
    if (environment.kind === 'unmarked') {
        return null;
    }

    const modifier = environment.kind === 'nonProduction' ? 'non-production' : 'production-data';

    return (
        <div {...classes(undefined, modifier)} aria-hidden="true" data-testid="environment-badge">
            <div {...classes('label')}>{environment.label}</div>
            <div {...classes('detail')}>{environment.detail}</div>
        </div>
    );
}
